module.exports = __webpack_public_path__ + "static/media/send_money.e963e7ad.svg";